import React from "react";
import StandardInstruction from "../StandardInstruction";

function PathBuilderInstructionsHat({ t, options }) {
  const show = options.buyHat || options.buildHat || options.integrateHat || options.print3DSeedSignerHatBox;
  if (!show) return null;

  return (
    <div className="instruction-category-group">
      <h3 className="instruction-category-header">{t("pathBuilder.categories.hat")}</h3>
      {options.buyHat && (
        <StandardInstruction
          title={t("pathBuilder.instructionTitles.buyHat")}
          icon="🛒"
          intro={
            <div style={{ marginBottom: "12px", padding: "8px 10px", background: "rgba(102, 126, 234, 0.1)", borderLeft: "3px solid rgba(102, 126, 234, 0.5)", borderRadius: "4px", color: "#b0b0b0", fontSize: "0.75em", lineHeight: "1.4", fontStyle: "italic" }}>
              {t("pathBuilder.instructionContent.buyHatNote")}
            </div>
          }
          steps={{
            items: [
              t("pathBuilder.instructionContent.buyHatStep1"),
              t("pathBuilder.instructionContent.buyHatStep2"),
              t("pathBuilder.instructionContent.buyHatStep3"),
              t("pathBuilder.instructionContent.buyHatStep4"),
            ],
          }}
          customContent={
            <>
              <div className="buy-link-container">
                <a href="https://satochip.io/product/seedsigner-extension-kit/" target="_blank" rel="noopener noreferrer" className="buy-link">
                  {t("pathBuilder.instructionContent.buyHatLink")}
                </a>
              </div>
              <div style={{ marginTop: "12px", paddingTop: "12px", borderTop: "1px solid rgba(102, 126, 234, 0.2)" }}>
                <p style={{ marginBottom: "8px", fontSize: "0.85em", color: "#b0b0b0", fontStyle: "italic" }}>{t("pathBuilder.instructionContent.buyHatAlsoAvailable")}</p>
                <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                  <a href="https://xmrstreet.store" target="_blank" rel="noopener noreferrer" className="buy-link" style={{ fontSize: "0.85em", padding: "6px 12px" }}>
                    {t("pathBuilder.instructionContent.buyHatBelgium")}
                  </a>
                  <a href="https://cryptoguide.tips/shop/" target="_blank" rel="noopener noreferrer" className="buy-link" style={{ fontSize: "0.85em", padding: "6px 12px" }}>
                    {t("pathBuilder.instructionContent.buyHatCanada")}
                  </a>
                  <a href="https://www.gobrrr.me" target="_blank" rel="noopener noreferrer" className="buy-link" style={{ fontSize: "0.85em", padding: "6px 12px" }}>
                    {t("pathBuilder.instructionContent.buyHatAustria")}
                  </a>
                </div>
              </div>
            </>
          }
        />
      )}
      {options.buildHat && (
        <StandardInstruction
          title={t("pathBuilder.instructionTitles.buildHat")}
          icon="🔧"
          intro={
            <div style={{ marginBottom: "12px", padding: "8px 10px", background: "rgba(102, 126, 234, 0.1)", borderLeft: "3px solid rgba(102, 126, 234, 0.5)", borderRadius: "4px", color: "#b0b0b0", fontSize: "0.75em", lineHeight: "1.4", fontStyle: "italic" }}>
              {t("pathBuilder.instructionContent.buyHatNote")}
            </div>
          }
          steps={{
            items: [
              t("pathBuilder.instructionContent.buildHatStep1"),
              t("pathBuilder.instructionContent.buildHatStep2"),
              t("pathBuilder.instructionContent.buildHatStep3"),
              t("pathBuilder.instructionContent.buildHatStep4"),
            ],
          }}
        />
      )}
      {options.integrateHat && (
        <StandardInstruction
          title={t("pathBuilder.instructionTitles.integrateHat")}
          icon="🎩"
          intro={
            <div style={{ marginBottom: "12px", padding: "8px 10px", background: "rgba(102, 126, 234, 0.1)", borderLeft: "3px solid rgba(102, 126, 234, 0.5)", borderRadius: "4px", color: "#b0b0b0", fontSize: "0.75em", lineHeight: "1.4", fontStyle: "italic" }}>
              {t("pathBuilder.instructionContent.buyHatNote")}
            </div>
          }
          steps={{
            items: [
              t("pathBuilder.instructionContent.integrateHatStep1"),
              t("pathBuilder.instructionContent.integrateHatStep2"),
              t("pathBuilder.instructionContent.integrateHatStep3"),
              t("pathBuilder.instructionContent.integrateHatStep4"),
              t("pathBuilder.instructionContent.integrateHatStep5"),
            ],
          }}
        />
      )}
      {options.print3DSeedSignerHatBox && (
        <StandardInstruction
          title={t("pathBuilder.instructionTitles.print3DHatBox")}
          icon="🖨️"
          intro={
            <div style={{ marginBottom: "12px", padding: "8px 10px", background: "rgba(102, 126, 234, 0.1)", borderLeft: "3px solid rgba(102, 126, 234, 0.5)", borderRadius: "4px", color: "#b0b0b0", fontSize: "0.75em", lineHeight: "1.4", fontStyle: "italic" }}>
              {t("pathBuilder.instructionContent.buyHatNote")}
            </div>
          }
          steps={{
            items: [
              t("pathBuilder.instructionContent.print3DHatBoxStep1"),
              t("pathBuilder.instructionContent.print3DHatBoxStep2"),
              t("pathBuilder.instructionContent.print3DHatBoxStep3"),
              t("pathBuilder.instructionContent.print3DHatBoxStep4"),
              t("pathBuilder.instructionContent.print3DHatBoxStep5"),
              t("pathBuilder.instructionContent.print3DHatBoxStep6"),
              t("pathBuilder.instructionContent.print3DHatBoxStep7"),
              t("pathBuilder.instructionContent.print3DHatBoxStep8"),
              t("pathBuilder.instructionContent.print3DHatBoxStep9"),
            ],
          }}
          customContent={
            <>
              <div className="buy-link-container">
                <a href="https://www.printables.com/model/1300792-seedsigner-smartcard-reader-hat" target="_blank" rel="noopener noreferrer" className="buy-link">
                  {t("pathBuilder.instructionContent.print3DHatBoxLink")}
                </a>
              </div>
              <div style={{ marginTop: "12px", paddingTop: "12px", borderTop: "1px solid rgba(102, 126, 234, 0.2)" }}>
                <p style={{ marginBottom: "8px", fontSize: "0.85em", color: "#b0b0b0" }}>
                  <strong style={{ color: "#e0e0e0" }}>{t("pathBuilder.instructionContent.print3DHatBoxAlternative")}</strong> {t("pathBuilder.instructionContent.print3DHatBoxAlternativeDesc")}
                </p>
              </div>
            </>
          }
        />
      )}
    </div>
  );
}

export default PathBuilderInstructionsHat;
